import { render } from "./AcademicYearContent.vue?vue&type=template&id=01c7151a&ts=true"
import script from "./AcademicYearContent.vue?vue&type=script&lang=ts"
export * from "./AcademicYearContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__